import {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {LazyImage} from '../../../components/LazyImage';
import { TranslationContext } from "../../../context/TranslationContext";
import {isEmptyFrameVeneerConfiguration} from '../../../services/configurationMode.service';

/**
 * Composant affichant la vue iso d'une configuration
 */
class ConfigurationIsoViewComponent extends Component {
  static contextType = TranslationContext;
  static propTypes = {
    isoView: PropTypes.shape({
      previous: PropTypes.string,
      current: PropTypes.string,
    }),
  };

  state = {
    showPrevious: false, // A l'initialisation, on ne veut pas de l'ancienne image pour éviter un "flash"
  };

  componentWillReceiveProps = (newProps) => {
    if (newProps.isoView !== this.props.isoView) {
      // On a modifié la vue alors qu'elle était déjà affichée.
      // Dans ce cas, on va indiquer au composant LazyImage
      // l'image lowRes
      this.setState({
        showPrevious: true
      });
    }
  };

  render() {
    const t = this.context;
    const {isoView,config} = this.props;
    const isEmpty = isEmptyFrameVeneerConfiguration(config);
    return (
      <div className="ConfigurationIsoView">
        {isEmpty ? (
          <p className="EmptyFrameVeneerMessage">
            {t('config3d_message_empty_frame_veneer')}
          </p>
        ) : (config.monument.reference !== "ACC" || !isoView.loading) && (
        <LazyImage className="FullSize Monument background-page" lazy={false}
                   throttle={true}
                   priority={true}
                   //src={isoView.current}
                   src={isoView.current}
                   lowResImage={this.state.showPrevious && isoView.loading && isoView.previous}
                    frame={this.props.frame}
        />
        )}
        {!isEmpty && isoView.loading && (
          <p className="LoadingMessage">{t('config3d_message_regeneration_in_progress')}</p>
        )}
      </div>
    )
  }
}

export const ConfigurationIsoView = connect(
  (state) => ({
    isoView: state.isoView,
  })
)(ConfigurationIsoViewComponent);
